<!-- Need to add Loader when data is still in loading state, which can be go to the else -->
<div class="row">
  <div class="col-xl-9">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between border-bottom">
          <p>These are Tax Slabs which will be used to calculate tax when running a payroll.</p>
          <div class="d-flex align-items-center">
            <select id="financialYear" class="form-select" [formControl]="selectedFinancialYear">
              <option selected value="">Select Financial Year</option>
              <option *ngFor="let year of financialYears$ | async" [value]="year.endDate">
                {{ year.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="content">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Regime</th>
                <th>Lower Limit</th>
                <th>Upper Limit</th>
                <th>Rate Percent</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody *ngIf="taxSettings$ | async as taxSettings">
              <tr *ngFor="let item of taxSettings.taxSlabs; let i = index">
                <td>{{ item.regime }}</td>
                <td>{{ item.lowerLimit }}</td>
                <td>{{ item.upperLimit ?? '-' }}</td>
                <td>{{ item.ratePercent }}</td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      (click)="openEditModal(addTaxSlabModal, item)"
                      *appHasPermission="{ taxSlabs: ['edit'] }"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      (click)="openDeleteModal(deleteModal, item)"
                      *appHasPermission="{ taxSlabs: ['delete'] }"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 theiaStickySidebar" *appHasPermission="{ taxSlabs: ['add'] }">
    <div class="card">
      <div class="card-body">
        <!-- <div class="d-flex flex-column list-group settings-list"> -->
        <div class="d-grid">
          <button (click)="openModel(addTaxSlabModal)" class="btn btn-primary" type="button">
            + New Slab
          </button>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>

<!-- models -->

<!-- Add Tax Slab Modal -->
<ng-template #addTaxSlabModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add New Tax Slab</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <form [formGroup]="form">
      <div class="mb-4">
        <label for="financialYear" class="form-label"
          >Financial Year <span class="text-danger">*</span></label
        >
        <select id="financialYear" formControlName="financialYearId" class="form-select">
          <option *ngFor="let year of financialYears$ | async" [value]="year.id">
            {{ year.name }}
          </option>
        </select>
      </div>
      <div class="mb-4">
        <label for="regime" class="form-label">Regime <span class="text-danger">*</span></label>
        <input id="regime" type="text" class="form-control" formControlName="regime" />
        <div *ngIf="form.get('regime')?.errors?.['required']">
          <span class="text-danger">
            {{ getErrorMessage('regime') }}
          </span>
        </div>
      </div>
      <div class="mb-4">
        <label for="lowerLimit" class="form-label"
          >Lower Limit <span class="text-danger">*</span></label
        >
        <input
          appTrimInput
          id="lowerLimit"
          type="text"
          class="form-control"
          formControlName="lowerLimit"
        />
        <div *ngIf="form.get('lowerLimit')?.errors?.['required']">
          <span class="text-danger">
            {{ getErrorMessage('lowerLimit') }}
          </span>
        </div>
      </div>
      <div class="mb-4">
        <label for="upperLimit" class="form-label">Upper Limit </label>
        <input
          appTrimInput
          id="upperLimit"
          type="text"
          class="form-control"
          formControlName="upperLimit"
        />
      </div>
      <div class="mb-4">
        <label for="ratePercent" class="form-label"
          >Rate Percentage <span class="text-danger">*</span></label
        >
        <input
          appTrimInput
          id="ratePercent"
          type="text"
          class="form-control"
          formControlName="ratePercent"
        />
        <div *ngIf="form.get('ratePercent')?.errors?.['required']">
          <span class="text-danger">
            {{ getErrorMessage('ratePercent') }}
          </span>
        </div>
      </div>
      <div class="col-lg-12 text-end form-wizard-button">
        <button
          type="submit"
          (click)="sendData()"
          class="btn btn-primary wizard-next-btn"
          [disabled]="!form.get('financialYearId')?.valid"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</ng-template>
<!-- /Add Termination -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the entry, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="sendData()">Yes, Delete</a>
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->
